// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1z6aY","footer":"ModalInfo_footer__3r0Cr"};